import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairporttopunecab() {



const cardData = {
  keyword: "Mumbai Airport to Pune Cabs",
  heading: "Lotus Cab: Mumbai Airport to Pune Cabs",

  headingDescription:
    "Lotus Cabs offers reliable and affordable Mumbai Airport to Pune Cab services for business travelers, corporate executives, families, students, tourists, airport transfers, and one-way or round-trip journeys. We provide a premium fleet of Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional and experienced chauffeurs. With 24x7 booking support, flight tracking, transparent pricing, doorstep drop anywhere in Pune, and safe travel via the Mumbai–Pune Expressway, Lotus Cabs ensures a smooth, comfortable, and hassle-free airport transfer experience from Chhatrapati Shivaji Maharaj International Airport to Pune.",


  top: "Top Places to Visit in Pune After Airport Transfer",

 topPlaces: [
    {
        title: "Shaniwar Wada",
        description:
            "Shaniwar Wada is Pune's most iconic historical monument and one of the city's top tourist attractions. Once the seat of the Peshwa rulers of the Maratha Empire, the fort is admired for its grand architecture, beautiful gardens, massive entrance gates, and evening light and sound show. Travelers arriving from Mumbai Airport often begin their Pune sightseeing journey with a visit to this remarkable heritage landmark."
    },
    {
        title: "Shreemant Dagdusheth Halwai Ganpati Temple",
        description:
            "Shreemant Dagdusheth Halwai Ganpati Temple is one of Maharashtra's most famous and revered temples dedicated to Lord Ganesha. The beautifully decorated idol, vibrant festivals, and peaceful spiritual atmosphere attract thousands of devotees every day. It is one of the first religious destinations visited by travelers arriving in Pune from Mumbai Airport."
    },
    {
        title: "Aga Khan Palace",
        description:
            "Aga Khan Palace is a nationally significant historical monument associated with Mahatma Gandhi and India's freedom movement. Featuring elegant Italian architecture, lush green gardens, and a museum displaying historical artifacts, it is a must-visit destination for history enthusiasts and tourists exploring Pune."
    },
    {
        title: "Sinhagad Fort",
        description:
            "Sinhagad Fort is one of Maharashtra's most celebrated hill forts and is closely linked to the bravery of Tanaji Malusare and Chhatrapati Shivaji Maharaj. The fort offers panoramic mountain views, traditional Maharashtrian food, and exciting trekking opportunities, making it a favorite destination for families and adventure lovers."
    },
    {
        title: "Khadakwasla Dam",
        description:
            "Khadakwasla Dam is a picturesque getaway on the outskirts of Pune, offering scenic reservoir views, cool breezes, and peaceful surroundings. Visitors enjoy evening walks, local snacks, and spectacular sunset views, making it a perfect destination for relaxation after arriving from Mumbai Airport."
    },
    {
        title: "Raja Dinkar Kelkar Museum",
        description:
            "Raja Dinkar Kelkar Museum houses one of India's finest collections of antiques, traditional artwork, sculptures, musical instruments, textiles, and historical artifacts. It provides visitors with a fascinating insight into India's rich cultural and artistic heritage while exploring Pune's historical attractions."
    },
    {
        title: "Pataleshwar Cave Temple",
        description:
            "Pataleshwar Cave Temple is an ancient 8th-century rock-cut temple dedicated to Lord Shiva, located in the heart of Pune. The temple is admired for its remarkable stone architecture, peaceful atmosphere, and religious significance, making it a popular destination for pilgrims and history lovers."
    },
    {
        title: "Rajiv Gandhi Zoological Park",
        description:
            "Rajiv Gandhi Zoological Park is one of Pune's leading family attractions, featuring a wide variety of wildlife, reptiles, birds, and a dedicated snake park. The spacious park offers educational experiences and recreational activities, making it an excellent destination for families traveling with children."
    },
    {
        title: "Parvati Hill Temple",
        description:
            "Parvati Hill is one of Pune's oldest heritage landmarks and offers panoramic views of the entire city from its hilltop temple complex. Visitors climb the historic stone steps to explore ancient temples dedicated to Lord Shiva and Goddess Parvati while enjoying breathtaking sunrise and sunset views."
    },
    {
        title: "Phoenix Marketcity Pune",
        description:
            "Phoenix Marketcity is one of Pune's largest shopping and entertainment destinations, featuring premium international brands, fine dining restaurants, cafés, multiplex cinemas, gaming zones, and family entertainment. Travelers arriving from Mumbai Airport frequently visit the mall for shopping, dining, and leisure before continuing their stay in Pune."
    }
],

  services: [
    {
      name: "Mumbai Airport to Pune Cab",
      description:
        "Lotus Cab offers direct airport transfer service from Mumbai Airport to Pune with punctual pickup and professional chauffeurs. Our drivers monitor flight arrivals to avoid delays and waiting confusion. The service is available 24/7 for domestic and international arrivals. Clean and fully air-conditioned vehicles ensure comfortable long-distance travel. Transparent per-km pricing eliminates hidden charges. Ideal for families, business travelers, and tourists. Safe highway driving via Mumbai-Pune Expressway guaranteed."
    },
    {
      name: "AC Cab Mumbai Airport to Pune",
      description:
        "Fully air-conditioned cab service ensures relaxed travel in all seasons. Comfortable seating and clean interiors enhance long-distance ride experience. Ideal for summer and humid weather travel conditions. Professional drivers ensure smooth driving. Available in sedan, SUV, and premium categories. Flexible one-way and round-trip packages offered. Transparent pricing with easy booking."
    },
    {
      name: "Sedan Cab Mumbai Airport to Pune",
      description:
        "Sedan cab option is ideal for small families and solo travelers. Comfortable 4-seater vehicles provide smooth highway performance. Fuel-efficient and budget-friendly travel solution. Perfect for business airport transfers. AC interiors ensure comfortable ride. Experienced chauffeurs ensure punctual service. Affordable per-km pricing available."
    },
    {
      name: "SUV Cab Mumbai Airport to Pune",
      description:
        "SUV cabs provide spacious seating and luggage capacity for families and groups. Stable highway performance ensures safe expressway travel. Ideal for long-distance comfort. Suitable for 5–7 passengers. AC and clean interiors maintained regularly. Professional drivers ensure safe journey. Flexible booking options available."
    },
    {
      name: "Luxury Cab Mumbai Airport to Pune",
      description:
        "Luxury airport transfer service designed for executives and VIP guests. Premium interiors and smooth performance enhance comfort. Ideal for corporate travelers and special guests. Chauffeur-driven executive vehicles available. Flexible pickup coordination. Transparent premium pricing. Professional and discreet service guaranteed."
    },
    {
      name: "Mini Bus Mumbai Airport to Pune",
      description:
        "Mini bus airport transfer is ideal for large groups and corporate teams. Comfortable group seating with luggage space. AC facility ensures relaxed long-distance travel. Professional drivers handle highway coordination. Suitable for events and family gatherings. Affordable group pricing available. Safe and punctual service."
    }
  ],

  tableData: [
    ["Mumbai Airport to Pune Cab", "AC Cab Mumbai Airport to Pune"],
    ["Sedan Cab Mumbai Airport to Pune", "SUV Cab Mumbai Airport to Pune"],
    ["Luxury Cab Mumbai Airport to Pune", "Online Taxi Booking Mumbai Airport to Pune"],
    ["Family Trip Cab Mumbai Airport to Pune", "Corporate Cab Mumbai Airport to Pune"],
    ["One Way Cab Mumbai Airport to Pune", "Round Trip Cab Mumbai Airport to Pune"],
    ["Outstation Taxi Service Mumbai Airport to Pune", "Mini Bus Mumbai Airport to Pune"],
    ["Innova Crysta Cab Mumbai Airport to Pune", "Swift Dzire Cab Mumbai Airport to Pune"],
    ["Kia Carens Cab Mumbai Airport to Pune", "Chauffeur Driven Cab Mumbai Airport to Pune"],
    ["Per Km Rate Cab Mumbai Airport to Pune", "Same Day Return Cab Mumbai Airport to Pune"],
    ["Budget Cab Mumbai Airport to Pune", "Airport Pickup Cab Mumbai to Pune"]
  ],

  whychoose: [
    {
      WhyChooseheading: "24/7 Airport Pickup Support",
      WhyChoosedescription:
        "We provide round-the-clock airport pickup service for domestic and international arrivals. Our drivers track flight status in real time to adjust pickup timing. No extra waiting charges for minor delays. Professional greeting and luggage assistance included. Safe and punctual service guaranteed."
    },
    {
      WhyChooseheading: "Professional Chauffeur Driven Service",
      WhyChoosedescription:
        "All drivers are background-verified and trained for highway driving. They are experienced in expressway travel and alternate route management. Courteous behavior ensures pleasant journey. Safe driving practices followed strictly. Reliable and disciplined service."
    },
    {
      WhyChooseheading: "Transparent Per Km Pricing",
      WhyChoosedescription:
        "Clear and upfront pricing shared before booking confirmation. No hidden toll or surprise charges. Flexible one-way and round-trip pricing models available. Affordable rates across vehicle categories. Honest billing structure."
    },
    {
      WhyChooseheading: "Wide Vehicle Options",
      WhyChoosedescription:
        "Choose from sedan, SUV, luxury, and mini bus options. Suitable for solo travelers and large groups. Clean and well-maintained fleet. AC facility in all vehicles. Flexible vehicle selection based on requirement."
    },
    {
      WhyChooseheading: "Safe Expressway Travel",
      WhyChoosedescription:
        "Drivers are experienced in Mumbai-Pune Expressway driving. Vehicles undergo regular maintenance checks. Highway safety standards strictly followed. Smooth and comfortable ride guaranteed."
    },
    {
      WhyChooseheading: "Flexible Booking Options",
      WhyChoosedescription:
        "One-way drop, round-trip, and same-day return packages available. Online booking and instant confirmation. Easy payment options provided."
    },
    {
      WhyChooseheading: "Corporate & Family Friendly",
      WhyChoosedescription:
        "Special packages for corporate airport transfers and family travel. Invoice support for business bookings. Spacious vehicles for group comfort."
    },
    {
      WhyChooseheading: "Reliable Customer Support",
      WhyChoosedescription:
        "Dedicated 24/7 support team available. Quick response to booking queries. Assistance during entire travel duration."
    }
  ]
};

const faqData = [
  {
    question: "Do you provide 24/7 Mumbai Airport to Pune cab service?",
    answer:
      "Yes, Lotus Cab operates 24/7 airport transfer service from Mumbai Airport to Pune. Our drivers are available for late-night and early-morning arrivals. We track flight timings to ensure punctual pickup. No need to worry about delays. Service is available for domestic and international terminals."
  },
  {
    question: "Is one-way drop available from Mumbai Airport to Pune?",
    answer:
      "Yes, we offer affordable one-way cab service where you pay only for single-side travel. This is ideal for airport transfers and business trips. Transparent per-km pricing is shared before booking. No hidden charges applied."
  },
  {
    question: "What vehicle options are available?",
    answer:
      "We provide sedan, SUV, Innova Crysta, luxury cars, and mini buses. Customers can choose vehicle type based on group size and budget. All vehicles are AC and well-maintained."
  },
  {
    question: "Do you offer corporate airport transfers?",
    answer:
      "Yes, corporate cab service is available with invoice billing support. Ideal for business travelers and company staff airport pickups."
  },
  {
    question: "Is same-day return possible?",
    answer:
      "Yes, same-day return packages are available for flexible travel planning."
  },
  {
    question: "Are toll charges included?",
    answer:
      "Toll charges are clearly mentioned during booking. Transparent billing policy followed."
  },
  {
    question: "Is luggage support available?",
    answer:
      "Yes, drivers assist with luggage loading and unloading."
  },
  {
    question: "Is online booking available?",
    answer:
      "Yes, online booking with instant confirmation is available 24/7."
  },
  {
    question: "Is AC available in all vehicles?",
    answer:
      "Yes, all vehicles are fully air-conditioned for comfortable travel."
  },
  {
    question: "Is family-friendly service available?",
    answer:
      "Yes, spacious vehicles are available for family travel with safety and comfort."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Mehta",
    feedback:
      "Booked airport pickup from Mumbai to Pune. The driver was punctual and very professional. Smooth expressway ride and clean vehicle. Highly reliable service.",
    rating: 5
  },
  {
    id: 2,
    name: "Corporate Client",
    feedback:
      "We regularly use Lotus Cab for corporate airport transfers. Always on time and professional service. Transparent billing and smooth coordination.",
    rating: 5
  },
  {
    id: 3,
    name: "Mrs. Priya Sharma",
    feedback:
      "Travelled with family from Mumbai Airport to Pune. SUV was spacious and comfortable. Driver was courteous and helpful with luggage.",
    rating: 5
  },
  {
    id: 4,
    name: "Mr. Ketan Patil",
    feedback:
      "Excellent airport transfer service. Smooth journey and no hidden charges. Highly recommended for long-distance travel.",
    rating: 5
  }
];



























































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai Airport to Pune Cab",
"image": "https://lotuscab.com/assets/images/mumbai-airport-to-pune-cab.jpg",
"description": "Book Mumbai Airport to Pune Cab with Lotus Cab for safe, reliable, and comfortable airport transfers. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 with instant booking confirmation and professional drivers.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7583"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹12/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/mumbai-airport-to-pune-cab"
}
};









  return (
    <div>
      
<Helmet>
  <title>Mumbai Airport to Pune Cab | Airport Taxi Service | +91 8767592195</title>

<meta
 name="description"
 content="Book Mumbai Airport to Pune Cab with Lotus Cab for reliable airport transfers. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7. Affordable fares, professional drivers, and instant booking confirmation."
/>

<meta
 name="keywords"
 content="Mumbai Airport to Pune Cab, Mumbai Airport to Pune Taxi, Pune Cab from Mumbai Airport, CSMIA to Pune Cab, Airport Taxi Mumbai to Pune, One Way Cab Mumbai Airport to Pune, Round Trip Cab Mumbai Airport to Pune, Mumbai Airport Pickup Cab Pune, Affordable Mumbai Airport to Pune Cab, Cheap Mumbai Airport Taxi Pune, Online Airport Cab Booking Pune, Sedan Cab Mumbai Airport to Pune, SUV Cab Mumbai Airport to Pune, Best Airport Cab Pune, Lotus Cab Mumbai Airport Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/57.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairporttopunecab;